import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de3bd17dbe0d82/components/forms/ContactForm.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de3bd17dbe0d82/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de3bd17dbe0d82/app/[locale]/contact/contact.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleMapLazy"] */ "/tmp/8de3bd17dbe0d82/components/ui/GoogleMapLazy.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de3bd17dbe0d82/components/ui/Section.module.css");
